/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    const messages = window.appTranslations;
    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = $('.permission-tree :checkbox');

    permissionTree.on('click change', function () {
        if ($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if ($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function (e) {
        e.preventDefault();

        Swal.fire({
            title: messages.deleteConfirmation,
            showCancelButton: true,
            confirmButtonText: messages.confirmDelete,
            cancelButtonText: messages.cancel,
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
            .on('submit', 'form[name=confirm-item]', function (e) {
                e.preventDefault();

                Swal.fire({
                    title: messages.actionConfirmation,
                    showCancelButton: true,
                    confirmButtonText: messages.continue,
                    cancelButtonText: messages.cancel,
                    icon: 'warning'
                }).then((result) => {
                    if (result.value) {
                        this.submit()
                    } else {
                        enableSubmitButtons($(this));
                    }
                });
            })
            .on('click', 'a[name=confirm-item]', function (e) {
                /**
                 * Add an 'are you sure' pop-up to any button/link
                 */
                e.preventDefault();

                Swal.fire({
                    title: messages.actionConfirmation,
                    showCancelButton: true,
                    confirmButtonText: messages.continue,
                    cancelButtonText: messages.cancel,
                    icon: 'info',
                }).then((result) => {
                    result.value && window.location.assign($(this).attr('href'));
                });
            });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="' + hash + '"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();

    // Mostra la richiesta conferma per cestinare gli utenti.



    $('.c-sidebar').on('mouseenter', function (e) {
        e.preventDefault();
        el = $(e.currentTarget);
        el.addClass("c-sidebar-hovered");
    }).on('mouseleave', function (e) {
        e.preventDefault();
        el = $(e.currentTarget);
        el.removeClass("c-sidebar-hovered");
    });

    //$(document).ready(function () {
    $('.floating-number').keypress(function (e) {
        var charCode = (e.which) ? e.which : event.keyCode
        if (String.fromCharCode(charCode).match(/[^0-9\.]/g)) {
            return false;
        } else if (String.fromCharCode(charCode).match(/\./g) && $(e.target).val().toString().match(/\./g)) {
            return false;
        }

        maxValue = false;
        if ($(e.target).attr('max')) {
            maxValue = $(e.target).attr('max');
        } else if ($(e.target).data('max')) {
            maxValue = $(e.target).data('max');
        }
        if (maxValue) {
            if (parseFloat($(e.target).val().toString().concat(String.fromCharCode(charCode))) > maxValue) {
                return false;
            }
        }

        minValue = false;
        if ($(e.target).attr('min')) {
            minValue = $(e.target).attr('min');
        } else if ($(e.target).data('min')) {
            minValue = $(e.target).data('min');
        }

        if (minValue) {
            if (parseFloat($(e.target).val().toString().concat(String.fromCharCode(charCode))) < minValue) {
                return false;
            }
        }
    });

    $('.integer-number').keypress(function (e) {
        var charCode = (e.which) ? e.which : event.keyCode
        if (String.fromCharCode(charCode).match(/[^0-9]/g)) {
            return false;
        }

        maxValue = false;
        if ($(e.target).attr('max')) {
            maxValue = $(e.target).attr('max');
        } else if ($(e.target).data('max')) {
            maxValue = $(e.target).data('max');
        }

        if (maxValue) {
            if (parseInt($(e.target).val().toString().concat(String.fromCharCode(charCode))) > maxValue) {
                return false;
            }
        }

        minValue = false;
        if ($(e.target).attr('min')) {
            minValue = $(e.target).attr('min');
        } else if ($(e.target).data('min')) {
            minValue = $(e.target).data('min');
        }

        if (minValue) {
            if (parseInt($(e.target).val().toString().concat(String.fromCharCode(charCode))) < minValue) {
                return false;
            }
        }
    });

    // Global Listeners

    window.addEventListener('alert', event => {
        let type = event.detail.type.toUpperCase();

        let configs = {
            title: event.detail.message,
            status: TOAST_STATUS[type],
            timeout: 6000,
            message: ""
        };
        Toast.create(configs);
    });

    window.addEventListener('focusOnValidateError', event => {
        el = $(document).find(".is-invalid").first().filter(':visible');
        parent = el.parents(".form-group");
        pointTo = parent.offset().top - parent.outerHeight(true);

        $('html').animate({'scrollTop': pointTo});
        el.focus();
    });

    $('[type="password"]').each(function () {
        var input = $(this);
        var eye_btn = $(this).parent().find('.input-group-text');
        eye_btn.css('cursor', 'pointer').addClass('input-password-hide');
        eye_btn.on('click', function () {
            if (eye_btn.hasClass('input-password-hide')) {
                eye_btn.removeClass('input-password-hide').addClass('input-password-show');
                eye_btn.find('.fa').removeClass('fa-eye').addClass('fa-eye-slash')
                input.attr('type', 'text');
            } else {
                eye_btn.removeClass('input-password-show').addClass('input-password-hide');
                eye_btn.find('.fa').removeClass('fa-eye-slash').addClass('fa-eye')
                input.attr('type', 'password');
            }
        });
    });


    function calculate_correct_total_on_checkout() {
        const form = document.getElementById('checkout_form');

        if (form) {
            const washingNumberAndPriceInputs = form.querySelectorAll('input[name="washingNumber_price"]');
            const cyclesNumberSelect = form.querySelector('select[name="cyclesNumber"]');

            if (washingNumberAndPriceInputs && cyclesNumberSelect) {

                washingNumberAndPriceInputs.forEach(function (washingNumberAndPriceInput) {
                    const parts = washingNumberAndPriceInput.value.split("_");

                    if (parts.length > 1) {
                        const price = parts[1];
                        const macNum = parts[0];

                        const cyclesNumber = parseInt(cyclesNumberSelect.value);
                        const newPrice = (price * cyclesNumber) / 100;

                        const priceLabel = form.querySelector('#price_' + macNum);
                        if (priceLabel) {
                            priceLabel.textContent = newPrice.toFixed(2); // Imposta il testo del label con il prezzo calcolato
                        }
                    }
                });

            }
        }
    }

// Aggiungiamo gli event listener solo se il form con ID "checkout_form" esiste
    const checkoutForm = document.getElementById('checkout_form');
    if (checkoutForm) {
        checkoutForm.querySelectorAll('select[name="cyclesNumber"]').forEach(function (selectElement) {
            selectElement.addEventListener("change", calculate_correct_total_on_checkout);
        });
    }

    calculate_correct_total_on_checkout();

});

